// src/components/ScrollToTopOnNavigate.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Cada vez que cambie la ruta o el hash,
 * si no hay hash (ancla) la página hará scroll a top:0.
 */
export default function ScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
